import { isEmpty, omit } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

const LEAVE_DURATION = 180;

const useLeaving = () => {
  const [leaving, setLeaving] = useState({});
  const timersRef = useRef(new Set());

  useEffect(() => {
    const timers = timersRef.current;
    return () => timers.forEach(clearTimeout);
  }, []);

  const startLeaving = useCallback((entries) => {
    const ids = Object.keys(entries);
    if (isEmpty(ids)) return;
    setLeaving((current) => ({ ...current, ...entries }));
    const timer = setTimeout(() => {
      timersRef.current.delete(timer);
      setLeaving((current) => omit(current, ids));
    }, LEAVE_DURATION);
    timersRef.current.add(timer);
  }, []);

  return { leaving, startLeaving };
};

export default useLeaving;
